import type { I } from '@/types/project';
import { isUndefined, isNull } from 'lodash-es';

export const hasOwnPeriod = (status: number | null | undefined) => {
  return status === 1 || status === 0;
};

export const hasSharePeriod = (status: number | null | undefined) => {
  return status === 1 || status === 0;
};

/**
 * 业务函数
 * 账期处理
 */
interface IPeriodCount {
  ownPeriodStatus: number | undefined | null;
  sharePeriodStatus: number | undefined | null;
}
/**
 * 企业接入金融账期需求
 * 判断账期个数 1：激活/正常 0：冻结 -1：注销/无）
 */
export const getPeriodCount = ({
  ownPeriodStatus = 0,
  sharePeriodStatus = 0,
}: IPeriodCount) => {
  // 2个账期
  if (hasOwnPeriod(ownPeriodStatus) && hasSharePeriod(sharePeriodStatus)) {
    return 2;
  }
  // 1个账期
  if (hasOwnPeriod(ownPeriodStatus) || hasSharePeriod(sharePeriodStatus)) {
    return 1;
  }
  return 0;
};

interface ICanShowCredit {
  status: number | null;
  timeStatus: number | null;
  grayFinNewAccountEp: number | null;
}
/**
 * 是否显示月结账期的判断
 * 包括灰度控制逻辑
 * @return {Boolean}
 */
export const getCanShowCredit = ({
  status,
  timeStatus,
  grayFinNewAccountEp,
}: ICanShowCredit) => {
  const isCreditNormal = () => {
    return status === 1 && timeStatus === 1; // 正常
  };
  const isCreditFreeze = () => {
    return status === 2 && timeStatus === 1; // 禁用（冻结）
  };
  const isCreditOverdue = () => {
    return (
      (status === 1 && timeStatus === 3) || (status === 2 && timeStatus === 3)
    ); // 已过期
  };
  /**
   * 老账期迁移到新账期灰度中 1:老账期被迁移到新账期 0:未变化
   * 1:老账期被迁移到新账期  =》 账单菜单显示，页面显示为引导页
   */
  const isGrayFinNewAccountEp = () => {
    return grayFinNewAccountEp === 1;
  };

  const canShowCredit =
    isGrayFinNewAccountEp() ||
    isCreditNormal() ||
    isCreditFreeze() ||
    isCreditOverdue();

  return canShowCredit;
};
export const hasCheckAgree = (epAuthData: I.epAuthDataType) => {
  const { epType, transactionFrequency, epVerifyStatus } = epAuthData || {};
  if (isUndefined(transactionFrequency) || isNull(transactionFrequency)) {
    // null || undefined 当作异常处理
    return true;
  }
  // 客户属性：企业 &&（异常、中、高频）客户 需要校验, 低频、未知无需校验 && 企业已认证
  return epType === 1 && [-1, 2, 3].includes(transactionFrequency) && epVerifyStatus === 3;
}